

class PrepayOptions extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('.prepay-options--checkbox');
    this.list = this.querySelector('.prepay-options--options-list');
    this.footer = this.querySelector('.prepay-options--footer');
    this.footerFrequency = this.querySelector('.prepay-options--footer-frequency');
    this.footerPrice = this.querySelector('.prepay-options--footer-price');
    this.sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    // Try to find select first, if not found, try hidden input
    this.variantSelect = document.querySelector('select[name="id"]') || document.querySelector('input[name="id"]');

    if (this.sellingPlanInput) {
      this.sellingPlanDefaultID = this.sellingPlanInput.value;
    }

    this.productHandle = this.dataset.productHandle;
    this.defaultVariantTitle = this.dataset.variantTitle;
    this.currentVariantTitle = this.dataset.variantTitle;

    // Listen for variant changes to track current selection and re-render options
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant) {
        this.currentVariantTitle = e.detail.variant.title;
        // Re-render prepay options with the correct variant
        if (this.data) {
          this.renderPrePayOptions(this.currentVariantTitle);
        }
      }
    });

    if (this.checkbox) {
      this.checkbox.addEventListener('change', e => {
        if (this.list && this.footer) {
          this.list.classList.toggle('hidden', !e.target.checked);
          this.footer.classList.toggle('hidden', !e.target.checked);
        }

        if (e.target.checked) {
          this.preSelectPrePayOptions();
        } else {
          this.revertFormData();
        }
      });
    }

    this.getPrePayProducts().then(data => {
      this.data = data;
      
      this.appendToVariantSelect();
      this.renderPrePayOptions(this.defaultVariantTitle);
    }).catch(error => {
      console.error('Error loading prepay products:', error);
    });
  }

  revertFormData() {
    if (this.sellingPlanInput && this.sellingPlanDefaultID) {
      this.sellingPlanInput.value = this.sellingPlanDefaultID;
    }

    const checkedSwatch = document.querySelector('.swatch-item input:checked');
    if (checkedSwatch) {
      checkedSwatch.click();
      checkedSwatch.dispatchEvent(new Event('change'));
    }
  }

  appendToVariantSelect() {
    if (this.variantSelect && this.data) {
      for (const pre_pay_product of this.data.pre_pay_products) {
        if (pre_pay_product.variants.length) {
          for (const variant of pre_pay_product.variants) {
            let option = document.createElement('option');
            option.value = variant.id;
            option.innerText = variant.name;
            this.variantSelect.appendChild(option);
          }
        }
      }
    }
  }

  setActiveOption() {
    let selectedOption = this.querySelector('.swatch-item input:checked');

    if (selectedOption) {
      this.activeOptionName = selectedOption.value;
    } else {
      this.activeOptionName = null;
    }
  }

  preSelectPrePayOptions() {
    if (this.activeOptionName) {
      let prePayOptions = this.querySelectorAll('.swatch-item input');

      for (const prePayOption of prePayOptions) {
        if (prePayOption.value == this.activeOptionName) {
          prePayOption.click();
          prePayOption.dispatchEvent(new Event('change'));

          break;
        }
      }
    } else {
      const firstOption = this.querySelector('.swatch-item input');
      if (firstOption) {
        firstOption.click();
        firstOption.dispatchEvent(new Event('change'));
      }
    }
  }

  renderPrePayOptions(variantTitle) {

    if (this.data) {
      this.setActiveOption();

      // Use current variant title instead of parameter
      const matchTitle = this.currentVariantTitle || variantTitle;

      this.list.innerHTML = `
        <div class="swatch-list swatch swatch_options">
          ${this.data.pre_pay_products.map(pre_pay_product => {
            let active_variant = null;
            
            for (const variant of pre_pay_product.variants) {
              if (variant.name == matchTitle) {
                active_variant = variant;

                break;
              }
            }
            
            // Don't use fallback - require exact match
            // If no matching variant found, skip this prepay option
            if (!active_variant) {
              console.warn(`No matching variant found for "${variantTitle}" in prepay product`);
              return '';
            }
            
            return `
              <div class="swatch-item"> 
                <input id="${pre_pay_product.selling_plan_id}" data-variant-id="${active_variant.id}" data-variant-price="${active_variant.price}" type="radio" name="PrePayOptions" value="${pre_pay_product.selling_plan_name}">
                <div class="swatch-element available">
                  <label for="${pre_pay_product.selling_plan_id}">
                    <span>${pre_pay_product.selling_plan_name.split(' ')[0]}</span>
                    <span>${pre_pay_product.selling_plan_name.split(' ')[1]}S</span>
                  </label>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;

      this.bindPrePayOptionEvents();
      this.preSelectPrePayOptions();
    }
  }

  bindPrePayOptionEvents() {
    let prePayOptions = this.querySelectorAll('.swatch-item input');

    if (prePayOptions) {
      for (const prePayOption of prePayOptions) {
        prePayOption.addEventListener('change', this.prePayOptionClickHandler.bind(this));
      }
    }
  }

  prePayOptionClickHandler(e) {
    let target = e.target.closest('input');

    if (this.checkbox && this.checkbox.checked) {
      this.pagePrice = document.querySelector('.modal_price .money');

      if (this.footerFrequency) {
        this.footerFrequency.innerHTML = target.value;
      }
  
      if (this.footerPrice) {
        this.footerPrice.innerHTML = target.dataset.variantPrice;
      }

      if (this.pagePrice) {
        this.pagePrice.innerHTML = target.dataset.variantPrice;
      }
  
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = target.id;
        // Trigger change event on selling plan input
        this.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
  
      if (this.variantSelect && target.dataset.variantId) {
        console.log('Setting variant ID:', target.dataset.variantId);
        this.variantSelect.value = target.dataset.variantId;
        // Important: dispatch change event to notify the product form
        this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  getPrePayProducts = async () => await fetch(`/products/${this.productHandle}?view=pre-pay-data`).then(resp => resp.json())
}

customElements.define('prepay-options', PrepayOptions);

class GiftPrepayOptions extends HTMLElement {
  constructor() {
    super();

    this.list = this.querySelector('.prepay-options--options-list');
    this.footer = this.querySelector('.prepay-options--footer');
    this.footerFrequency = this.querySelector('.prepay-options--footer-frequency');
    this.footerPrice = this.querySelector('.prepay-options--footer-price');
    this.variantInput = document.querySelector('[data-gift-id]');
    this.giftModalPrice = document.getElementById('gift_modal_price');

    this.productHandle = this.dataset.productHandle;
    this.defaultVariantTitle = this.dataset.variantTitle;
  }

  giftTypeClickHandler(e) {
    this.getPrePayProducts(e.target.value).then(data => {
      this.data = data;
 console.log( this.data,'getPrePayProducts');
      this.renderPrePayOptions(this.defaultVariantTitle);
    }).catch(error => {
      console.error('Error loading gift prepay products:', error);
    });
  }

  setActiveOption() {
    let selectedOption = this.querySelector('.swatch-item input:checked');

    if (selectedOption) {
      this.activeOptionName = selectedOption.value;
    } else {
      this.activeOptionName = null;
    }
  }

  preSelectPrePayOptions() {
    if (this.activeOptionName) {
      let prePayOptions = this.querySelectorAll('.swatch-item input');

      for (const prePayOption of prePayOptions) {
        if (prePayOption.value == this.activeOptionName) {
          prePayOption.click();
          prePayOption.dispatchEvent(new Event('change'));

          break;
        }
      }
    } else {
      const firstOption = this.querySelector('.swatch-item input');
      if (firstOption) {
        firstOption.click();
        firstOption.dispatchEvent(new Event('change'));
      }
    }
  }

  renderPrePayOptions(variantTitle) {
    if (this.data) {
      console.log(variantTitle,'variantTitle');
      this.setActiveOption();

      this.list.innerHTML = `
        <div class="swatch-list swatch swatch_options">
          ${this.data.pre_pay_products.map(pre_pay_product => {
            return `
              <div class="swatch-item"> 
                <input id="${pre_pay_product.variant_id}" data-variant-price="${pre_pay_product.price}" type="radio" name="PrePayOptions" value="${pre_pay_product.title}">
                <div class="swatch-element available">
                  <label for="${pre_pay_product.variant_id}">
                    <span>${pre_pay_product.title.split(' ')[0]}</span>
                    <span>${pre_pay_product.title.split(' ')[1]}</span>
                  </label>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      `;

      this.bindPrePayOptionEvents();
      this.preSelectPrePayOptions();
    }
  }

  bindPrePayOptionEvents() {
    let prePayOptions = this.querySelectorAll('.swatch-item input');

    if (prePayOptions.length) {
      for (const prePayOption of prePayOptions) {
        prePayOption.addEventListener('change', this.prePayOptionClickHandler.bind(this));
      }
    }
  }

  prePayOptionClickHandler(e) {
    let target = e.target.closest('input');

    if (this.footerFrequency) {
      this.footerFrequency.innerHTML = target.value;
    }

    if (this.footerPrice) {
      this.footerPrice.innerHTML = target.dataset.variantPrice;
    }

    if (this.giftModalPrice) {
      this.giftModalPrice.innerHTML = target.dataset.variantPrice;
    }
console.log(this.variantInput,'this.variantInput');
    if (this.variantInput) {
      this.variantInput.value = target.id;
    }

   
  }

  getPrePayProducts = async handle => await fetch(`/products/${handle}?view=pre-pay-gift-data`).then(resp => resp.json())
}

customElements.define('giftprepay-options', GiftPrepayOptions);

class GiftTypes extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll('.swatch-item input');
    this.prePayOptions = document.querySelector('giftprepay-options');

    if (this.items) {
      for (const item of this.items) {
        item.addEventListener('click', e => {
          if (this.prePayOptions) {
            this.prePayOptions.giftTypeClickHandler(e);
          }
        });
      }

      this.items[0].click();
    }
  }
}

customElements.define('gift-types', GiftTypes);

document.addEventListener('DOMContentLoaded', e => {
  let tooltips = document.querySelectorAll('.prepay-options--tooltip');

  if (tooltips) {
    document.body.addEventListener('click', e => {
      if (!document.querySelector('.prepay-options--tooltip:hover')) {
        for (const tooltip of tooltips) {
          tooltip.open = false;
        }
      }
    });
  }
});